import _ from "lodash"

const alphanum = (alphanumString1, alphanumString2) => {
  const lowerString1 = _.toLower(alphanumString1)
  const lowerString2 = _.toLower(alphanumString2)

  if (lowerString1 === lowerString2) return 0
  else if (lowerString1 < lowerString2) return -1
  else return 1
}

const systemWildcardFirst = (alphanumString1, alphanumString2) => {
  if (alphanumString1 === alphanumString2) return 0
  if (alphanumString1.startsWith('*')) return -1
  else return 1
}

export { alphanum, systemWildcardFirst }